module.exports = __webpack_public_path__ + "static/media/David.5fd5c81a.jpg";